import { Toast } from '@modusign/design-system';
import {
  CreateTemplateRequestDto,
  UpdateTemplateRequestDto,
} from '@modusign/openapi-client-template/model';
import { AxiosError } from 'axios';
import { Dispatch } from 'redux';

import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';
import { isFieldsPositionValid } from '@app/libs/fields/isFieldsPositionValid';
import { modalOpen } from '@app/store/modal/actions';

export function templateMutationErrorHandler(
  dispatch: Dispatch,
  error: AxiosError,
  converted: CreateTemplateRequestDto | UpdateTemplateRequestDto,
  templateLimit: number
) {
  if (error.message === 'Title Validation Error') {
    Toast.error({
      title: '템플릿 저장 실패',
      description: '기타 설정에서 이름을 수정해 주세요.',
    });
  }

  if (error.response?.status === 400 && error.message === 'Validation failed') {
    if (!isFieldsPositionValid(converted.fields.map((f) => f.guide.position))) {
      dispatch(
        modalOpen('CONFIRM', {
          title: '수정 필요',
          content:
            '사인/도장 입력란이 문서 크기를 벗어났습니다.\n벗어난 사인/도장 입력란의 위치를 조정해 주세요.',
        })
      );
    } else {
      dispatch(
        modalOpen('CONFIRM', {
          title: '템플릿 저장 오류',
          content:
            '설정한 내용에 오류가 있어 템플릿을 저장할 수 없습니다.\n확인 후 다시 시도해 주제요.',
        })
      );
    }
  } else if (error.response?.status === 403) {
    dispatch(
      modalOpen('CONFIRM', {
        title: '새 템플릿 만들기',
        content: `템플릿 사용 개수(${templateLimit}개)를 초과할 수 없습니다.\n템플릿이 ${templateLimit}개 이하가 되도록\n삭제 후 다시 시도해 주세요.`,
      })
    );
  } else if (error.response?.status === 422) {
    if (error.message === 'OTP not verified') {
      dispatch(
        modalOpen('CONFIRM', {
          title: '템플릿 저장 실패',
          content: '이미지 입력의 파일을 삭제 후\n 다시 업로드해 주세요.',
        })
      );
    } else if (error.message === 'Token not verified') {
      dispatch(
        modalOpen('CONFIRM', {
          title: '템플릿 저장 실패',
          content: '첨부파일을 삭제 후\n 다시 업로드해 주세요.',
        })
      );
    }
  } else {
    dispatch(
      modalOpen('CONFIRM', {
        title: '템플릿 편집 실패',
        content: GLOBAL_ERROR_MESSAGE[error.message] || error.message,
      })
    );
  }
}
